import { UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { some, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { obj_type, option_type, unit_type, string_type, list_type, equals } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { SubproductDefinitionDTO$reflection } from "./Model.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { getCsrfEnabledRequest, ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Http_content, Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { BodyContent, HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { String100Module_value } from "../../WrappedString.js";
import { ProductModule_toInt } from "../../DomainTypes.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";

export function loadSubproductDefinitions(clientNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Subproduct/SubproductDefinition/%i/"))(clientNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(SubproductDefinitionDTO$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(SubproductDefinitionDTO$reflection()), arg_1, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(SubproductDefinitionDTO$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function saveSubproductDefinition(clientNr, product, name, dto) {
    let arg_2, arg_1;
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, (arg_2 = String100Module_value(name), (arg_1 = (ProductModule_toInt(product) | 0), toText(printf("/Subproduct/SubproductDefinition/%i/%i/%s/"))(clientNr)(arg_1)(arg_2)))));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_3 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(unit_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(unit_type, arg_3, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(option_type(SubproductDefinitionDTO$reflection())), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(some(dto)));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(2), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                let response_1;
                return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(unit_type, string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
            });
        });
    }
}

export function deleteSubproductDefinition(clientNr, name, productNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Subproduct/SubproductDefinition/%i/%s/%i/"))(clientNr)(name)(productNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_3 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(unit_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(unit_type, arg_3, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(obj_type), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(void 0));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(4), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                let response_1;
                return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(unit_type, string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
            });
        });
    }
}

export function createSubproductDefinition(clientNr, dto) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Subproduct/SubproductDefinition/%i/"))(clientNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(unit_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(unit_type, arg_1, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(SubproductDefinitionDTO$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(dto));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

